module.exports = new __parcel__URL__("discord.8dadf9a9.svg").toString();